import FiftyFifty from './FiftyFifty'

export default FiftyFifty
